import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import FormField from "./FormField";
import { useFormikContext } from "formik";

const StepFinalQualification = ({ fields }) => {
  const { values, errors, touched } = useFormikContext();

  const renderField = (fieldKey) => (
    <FormField
      {...fields[fieldKey]}
      error={errors[fieldKey]}
      touched={touched[fieldKey]}
    />
  );

  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <Grid container spacing={2}>
        {/* <Grid item xs={12} md={6}>
          {renderField("max_project_size")}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderField("total_annual_volume")}
        </Grid>
        <Grid item xs={12}>
          {renderField("number_of_employees")}
        </Grid> */}
        <Grid item xs={12}>
          {renderField("certifications")}
        </Grid>

        <Grid item xs={12} md={6}>
          {renderField("is_bonded")}
        </Grid>
        {values.is_bonded === "yes" && (
          <>
            <Grid item xs={12} md={6}>
              {renderField("bond_amount")}
            </Grid>
            <Grid item xs={12}>
              {renderField("bond_expiration_date")}
            </Grid>
          </>
        )}

        <Grid item xs={12}>
          {renderField("safety_violations_past_5_years")}
        </Grid>
        {values.safety_violations_past_5_years === "yes" && (
          <Grid item xs={12}>
            {renderField("safety_violations_details")}
          </Grid>
        )}

        <Grid item xs={12}>
          {renderField("pending_claims_suits")}
        </Grid>
        {values.pending_claims_suits === "yes" && (
          <Grid item xs={12}>
            {renderField("pending_claims_suits_details")}
          </Grid>
        )}

        <Grid item xs={12}>
          {renderField("felony_convictions")}
        </Grid>
        {values.felony_convictions === "yes" && (
          <Grid item xs={12}>
            {renderField("felony_convictions_details")}
          </Grid>
        )}

        <Grid item xs={12}>
          <Typography variant="h2" sx={{ color: "#242424", fontWeight: 600, mt: 4, mb: 2 }}>Warranty & Payouts</Typography>
        </Grid>

        <Grid item xs={12}>
          {renderField("offers_warranty")}
        </Grid>
        {values.offers_warranty === "yes" && (
          <Grid item xs={12}>
            {renderField("warranty_duration_text")}
          </Grid>
        )}

        {/* <Grid item xs={12} sx={{ mt: 2 }}>
          {renderField("w9_file")}
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default StepFinalQualification;
